import { call, put, take } from 'redux-saga/effects'
import api from '../api/api'
import { statusCodeIsBelow400, appendToFormData } from '../helpers/utility'
import schoolsSchema, { studentsOfSchoolSchema } from '../schemas/schools'
import { normalize } from 'normalizr'
import {
  FETCH_SCHOOLS_LIST_REQUEST,
  FETCH_SCHOOLS_LIST_SUCCESS,
  FETCH_SCHOOLS_LIST_FAIL,
  FETCH_SCHOOLS_LIST_ASYNC_START,
  FETCH_SCHOOLS_LIST_ASYNC_END,
} from '../actions/actions'
import {
  FETCH_SCHOOL_STUDENTS_REQUEST,
  FETCH_SCHOOL_STUDENTS_SUCCESS,
  FETCH_SCHOOL_STUDENTS_FAIL,
  FETCH_SCHOOL_STUDENTS_ASYNC_START,
  FETCH_SCHOOL_STUDENTS_ASYNC_END,
} from '../actions/actions'
import {
  REMOVE_STUDENT_FROM_SCHOOL_REQUEST,
  REMOVE_STUDENT_FROM_SCHOOL_SUCCESS,
  REMOVE_STUDENT_FROM_SCHOOL_FAIL,
  REMOVE_STUDENT_FROM_SCHOOL_ASYNC_END,
  REMOVE_STUDENT_FROM_SCHOOL_ASYNC_START,
} from '../actions/actions'
import {
  ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_END,
  ADD_SINGLE_STUDENT_TO_SCHOOL_SUCCESS,
  ADD_SINGLE_STUDENT_TO_SCHOOL_FAIL,
  ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_START,
  ADD_SINGLE_STUDENT_TO_SCHOOL_REQUEST,
} from '../actions/actions'

export function* getSchoolsList() {
  while (true) {
    const { queryString } = yield take(FETCH_SCHOOLS_LIST_REQUEST)
    yield put({ type: FETCH_SCHOOLS_LIST_ASYNC_START })

    try {
      const res = yield call(api.getSchoolsList, queryString)

      if (statusCodeIsBelow400(res.status)) {
        yield put({
          type: FETCH_SCHOOLS_LIST_SUCCESS,
          schools: normalize(res.data.data.schools, schoolsSchema),
          count: res.data.data.count,
        })
      } else {
        yield put({ type: FETCH_SCHOOLS_LIST_FAIL, error: res.errors.general_errors })
      }

      yield put({ type: FETCH_SCHOOLS_LIST_ASYNC_END })
    } catch (error) {
      console.log(error)

      yield put({ type: FETCH_SCHOOLS_LIST_ASYNC_END })
      yield put({ type: FETCH_SCHOOLS_LIST_FAIL, error })
    }
  }
}

export const getNormalizedStudentList = students => {
  const properListOfStudents = students.map(student => {
    let newStudent = Object.assign({}, {}, student.student)
    newStudent.academicYears = student.academic_year
    newStudent.grade = student.grade
    return newStudent
  })
  return normalize(properListOfStudents, studentsOfSchoolSchema)
}

export function* getStudentsOfSchool() {
  while (true) {
    const { schoolId, queryString = '' } = yield take(FETCH_SCHOOL_STUDENTS_REQUEST)
    yield put({ type: FETCH_SCHOOL_STUDENTS_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.fetchListOfStudentsOfSchool, schoolId, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SCHOOL_STUDENTS_SUCCESS,
          students: getNormalizedStudentList(data.students),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_SCHOOL_STUDENTS_FAIL, error: general_errors })
      }

      yield put({ type: FETCH_SCHOOL_STUDENTS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_SCHOOL_STUDENTS_ASYNC_END })
      yield put({ type: FETCH_SCHOOL_STUDENTS_FAIL, error })
      console.log(error)
    }
  }
}

export function* removeStudentFromSchool() {
  while (true) {
    const { schoolId, studentId } = yield take(REMOVE_STUDENT_FROM_SCHOOL_REQUEST)
    let formData = appendToFormData({ students: studentId })

    yield put({ type: REMOVE_STUDENT_FROM_SCHOOL_ASYNC_START })

    try {
      const {
        data: {
          status,
          errors: { general_errors },
        },
      } = yield call(api.removeStudentFormSchool, schoolId, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: REMOVE_STUDENT_FROM_SCHOOL_SUCCESS,
          studentId,
        })
      } else {
        yield put({
          type: REMOVE_STUDENT_FROM_SCHOOL_FAIL,
          error: general_errors,
        })
      }

      yield put({ type: REMOVE_STUDENT_FROM_SCHOOL_ASYNC_END })
    } catch (error) {
      yield put({ type: REMOVE_STUDENT_FROM_SCHOOL_ASYNC_END })
      yield put({ type: REMOVE_STUDENT_FROM_SCHOOL_FAIL, error })
      console.log(error)
    }
  }
}

export function* addSingleStudentToSchool() {
  while (true) {
    const { resolve, reject, formData } = yield take(ADD_SINGLE_STUDENT_TO_SCHOOL_REQUEST)

    yield put({ type: ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_START })

    try {
      const {
        data: { status, data, errors },
      } = yield call(api.addSingleStudentToSchool, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: ADD_SINGLE_STUDENT_TO_SCHOOL_SUCCESS,
          data,
        })

        resolve && resolve(data)
      } else {
        yield put({
          type: ADD_SINGLE_STUDENT_TO_SCHOOL_FAIL,
          errors,
        })

        reject && reject(errors)
      }
    } catch (error) {
      yield put({ type: ADD_SINGLE_STUDENT_TO_SCHOOL_FAIL, error })
    }

    yield put({ type: ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_END })
  }
}



// WEBPACK FOOTER //
// ./src/sagas/schoolsSaga.js